import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  svgStyle: {
    cursor: "grab !important",

    "&:hover circle": {
      fill: "#303030"
    }
  }
}));

function Drag(props) {
  const { color, className } = props;
  const classes = useStyles();
  const { t } = useTranslation(["styles", "translation"]);

  let style2 = {};
  if (props?.quickpropmenu) style2 = { display: "inline-flex", marginLeft: "-4%" };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={[className, classes.svgStyle].join(" ")}
      style={{ alignSelf: "center", ...style2 }}
      width="10"
      height="16"
      viewBox="0 0 10 16"
    >
      <title>{t(`translation:Drag to rearrange`)}</title>
      <defs></defs>
      <g transform="translate(1393 4761)">
        <circle className="a" fill={color || "#afafaf"} cx="2" cy="2" r="2" transform="translate(-1393 -4761)" />
        <circle className="a" fill={color || "#afafaf"} cx="2" cy="2" r="2" transform="translate(-1393 -4755)" />
        <circle className="a" fill={color || "#afafaf"} cx="2" cy="2" r="2" transform="translate(-1387 -4761)" />
        <circle className="a" fill={color || "#afafaf"} cx="2" cy="2" r="2" transform="translate(-1387 -4755)" />
        <circle className="a" fill={color || "#afafaf"} cx="2" cy="2" r="2" transform="translate(-1393 -4749)" />
        <circle className="a" fill={color || "#afafaf"} cx="2" cy="2" r="2" transform="translate(-1387 -4749)" />
      </g>
    </svg>
  );
}

export default Drag;
